import { useState } from "react";
import axios from "axios";
import { FaCheckCircle, FaTimes } from "react-icons/fa";

const Form = ({ formId = "" }) => {
  const clientKey = "buildingbibleintellect";
  const apiUrl = "https://7t0xfgk6y1.execute-api.eu-west-2.amazonaws.com/form";

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(null);
    setError(null);

    try {
      const response = await axios.post(apiUrl, {
        client: clientKey,
        formid: formId,
        name,
        email,
        message,
      });

      if (response.status === 200) {
        setSuccess("Your details have been submitted successfully!");
        setName("");
        setEmail("");
        setMessage("");
      } else {
        setError("Something went wrong, please try again.");
      }
    } catch (err) {
      console.error("Form error:", err);
      setError("Error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-sect-holder">
      <form onSubmit={handleSubmit}>
        <div className="form-sect">
          <div className="field">
            <label>Your name:</label>
            <input
              type="text"
              name="name"
              placeholder="Enter your name..."
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
        </div>

        <div className="form-sect">
          <div className="field">
            <label>Your email address:</label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email address..."
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
        </div>

        {(formId === "Contact" || formId === "Artist") && (
          <div className="form-sect">
            <div className="field">
              <label>Message:</label>
              <textarea
                name="message"
                placeholder="Enter your message..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>
          </div>
        )}

        <button type="submit" disabled={loading}>
          {loading ? "Sending..." : "Submit"}
        </button>
      </form>

      {success && (
        <div className="success-message">
          <FaCheckCircle />
          {success}
        </div>
      )}

      {error && (
        <div className="error-message">
          <FaTimes />
          {error}
        </div>
      )}
    </div>
  );
};

export default Form;
